import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import "./Birth.scss";
import arrow from "../../../assets/arrow.png";
import { useState } from "react";
import Footer from "../../../components/Footer/Footer";
import { Link } from "react-router-dom";
import axios from "axios";



export const destinyProfiles = {
1: {
    title: "Birth / Root Number 1 – The Independent",
    keywords: "Leadership · Confidence · Originality",
    overview:
      "Birth Number 1 represents a strong, independent personality. You naturally like to take charge and prefer doing things your own way.",
    strengths: [
      "Confident and self-motivated",
      "Natural leadership qualities",
      "Strong willpower and determination",
      "Independent thinker"
    ],
    challenges: [
      "Ego clashes",
      "Impatience",
      "Difficulty accepting authority",
      "Stubbornness"
    ],
    guidance:
      "Practice humility and patience. True leadership comes from understanding others."
  },

  2: {
    title: "Birth / Root Number 2 – The Sensitive Soul",
    keywords: "Cooperation · Emotions · Balance",
    overview:
      "Birth Number 2 indicates a gentle, emotional and peace-loving personality. You are naturally supportive and intuitive.",
    strengths: [
      "Emotionally intelligent",
      "Diplomatic and cooperative",
      "Good listener",
      "Supportive nature"
    ],
    challenges: [
      "Over-sensitivity",
      "Self-doubt",
      "Fear of confrontation",
      "Emotional dependency"
    ],
    guidance:
      "Build self-confidence. Your sensitivity is a strength when balanced with courage."
  },

  3: {
    title: "Birth / Root Number 3 – The Expressive",
    keywords: "Creativity · Joy · Communication",
    overview:
      "Birth Number 3 reflects a cheerful, expressive and creative personality. You naturally attract people with your charm and communication skills.",
    strengths: [
      "Creative thinking",
      "Excellent communication skills",
      "Optimistic attitude",
      "Socially engaging"
    ],
    challenges: [
      "Lack of focus",
      "Mood swings",
      "Avoiding responsibilities",
      "Inconsistency"
    ],
    guidance:
      "Channel your creativity with discipline to unlock long-term success."
  },

  4: {
    title: "Birth / Root Number 4 – The Practical One",
    keywords: "Stability · Discipline · Hard work",
    overview:
      "Birth Number 4 represents a grounded, practical and disciplined personality. You believe in structure, order and consistency.",
    strengths: [
      "Highly reliable",
      "Strong work ethic",
      "Organised mindset",
      "Trustworthy nature"
    ],
    challenges: [
      "Rigidity",
      "Resistance to change",
      "Overworking",
      "Pessimism"
    ],
    guidance:
      "Stay flexible. Growth happens when discipline meets openness."
  },

  5: {
    title: "Birth / Root Number 5 – The Freedom Lover",
    keywords: "Adaptability · Curiosity · Movement",
    overview:
      "Birth Number 5 shows a dynamic, adventurous and freedom-loving personality. You dislike routine and thrive on change.",
    strengths: [
      "Quick learner",
      "Adaptable nature",
      "Versatile skills",
      "Energetic personality"
    ],
    challenges: [
      "Restlessness",
      "Impulsiveness",
      "Commitment issues",
      "Scattered energy"
    ],
    guidance:
      "Focus and discipline will help you use your energy productively."
  },

  6: {
    title: "Birth / Root Number 6 – The Caregiver",
    keywords: "Responsibility · Love · Harmony",
    overview:
      "Birth Number 6 reflects a nurturing, responsible and caring personality. You naturally take care of people around you.",
    strengths: [
      "Loving and compassionate",
      "Strong sense of responsibility",
      "Family-oriented",
      "Artistic sense"
    ],
    challenges: [
      "Over-protectiveness",
      "Emotional burden",
      "Self-sacrifice",
      "Expecting appreciation"
    ],
    guidance:
      "Care for yourself as much as you care for others."
  },

  7: {
    title: "Birth / Root Number 7 – The Thinker",
    keywords: "Analysis · Introspection · Wisdom",
    overview:
      "Birth Number 7 indicates a thoughtful, introspective and analytical personality. You prefer depth over superficiality.",
    strengths: [
      "Sharp analytical mind",
      "Strong intuition",
      "Spiritual inclination",
      "Observation skills"
    ],
    challenges: [
      "Isolation",
      "Overthinking",
      "Emotional distance",
      "Trust issues"
    ],
    guidance:
      "Open up emotionally. Balance intellect with human connection."
  },

  8: {
    title: "Birth / Root Number 8 – The Strong-Willed",
    keywords: "Authority · Ambition · Control",
    overview:
      "Birth Number 8 represents a powerful, ambitious and authoritative personality. You naturally command respect.",
    strengths: [
      "Strong determination",
      "Leadership ability",
      "Practical mindset",
      "Goal-oriented nature"
    ],
    challenges: [
      "Control issues",
      "Workaholism",
      "Anger management",
      "Material obsession"
    ],
    guidance:
      "Balance ambition with empathy to maintain harmony."
  },

  9: {
    title: "Birth / Root Number 9 – The Compassionate",
    keywords: "Humanity · Emotions · Generosity",
    overview:
      "Birth Number 9 reflects a compassionate, emotional and humanitarian personality. You feel deeply for others.",
    strengths: [
      "Empathy and kindness",
      "Artistic expression",
      "Broad-minded thinking",
      "Emotional depth"
    ],
    challenges: [
      "Emotional sensitivity",
      "Difficulty letting go",
      "Over-giving",
      "Mood fluctuations"
    ],
    guidance:
      "Learn to release emotional baggage. Self-care is essential."
  },

  11: {
    title: "Birth / Root Number 11 – The Intuitive",
    keywords: "Intuition · Sensitivity · Awareness",
    overview:
      "Birth Number 11 is a Master Number that reflects heightened intuition, sensitivity and spiritual awareness.",
    strengths: [
      "Strong intuition",
      "Emotional depth",
      "Inspirational presence"
    ],
    challenges: [
      "Anxiety",
      "Emotional overload",
      "Self-doubt"
    ],
    guidance:
      "Ground yourself emotionally. Balance intuition with practicality."
  },

  22: {
    title: "Birth / Root Number 22 – The Grounded Visionary",
    keywords: "Stability · Responsibility · Vision",
    overview:
      "Birth Number 22 carries powerful practical energy combined with vision. You possess natural maturity and responsibility.",
    strengths: [
      "Strong discipline",
      "Practical mindset",
      "Ability to handle responsibility"
    ],
    challenges: [
      "Pressure",
      "Fear of making mistakes",
      "Over-responsibility"
    ],
    guidance:
      "Take one step at a time. Great stability is built through balance."
  },
};


const Birth = () => {

  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    year: "2000",
    month: "May",
    day: "26",
    gender: "male" // ✅ DEFAULT, NO UI
  });


  const [resultData, setResultData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showReport, setShowReport] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { firstName, lastName, year, month, day } = formData;
    const birthDay = Number(day);
    const birthMonth = new Date(`${month} 1, 2000`).getMonth() + 1;
    const birthYear = Number(year);

    try {
      setLoading(true);

      const { gender } = formData;

      const res = await axios.get(
        `https://core-c343.onrender.com/api/lucky-number` +
        `?firstName=${firstName}` +
        `&lastName=${lastName}` +
        `&birthYear=${birthYear}` +
        `&birthMonth=${birthMonth}` +
        `&birthDay=${birthDay}` +
        `&gender=${gender}`
      );


      setResultData(res.data);
      setShowReport(true);
    } catch (err) {
      setResultData({
        error: "Unable to generate your Destiny Number report. Please try again.",
      });
      setShowReport(true);
    } finally {
      setLoading(false);
    }
  };

  const handleTryAgain = () => {
    setShowReport(false);
    setResultData(null);
  };

  const destinyNum = resultData?.data?.numerology?.birthNumber;
  const profile = destinyNum ? destinyProfiles[destinyNum] : null;

  return (
    <div className="destiny-container">
      <InnerNav />

      <div className="destiny-content">
        <Zodiac />

        <div className="left-numerology">

          {/* FORM VIEW */}
          {!showReport && (
            <>
              <div className="header">
                <h1>Birth / Root Calculator</h1>
                <p>
                  Enter your birth details to discover your <strong>core personality, natural traits, and inborn tendencies</strong>.
                </p>
              </div>

              <div className="form-card">
                <form onSubmit={handleSubmit} className="form-grid">

                  <input
                    name="firstName"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />

                  <input
                    name="middleName"
                    placeholder="Middle Name (Optional)"
                    value={formData.middleName}
                    onChange={handleChange}
                  />

                  <input
                    name="lastName"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />

                  <div className="dob-grid">
                    <select name="day" value={formData.day} onChange={handleChange}>
                      {[...Array(31)].map((_, i) => (
                        <option key={i + 1}>{i + 1}</option>
                      ))}
                    </select>

                    <select name="month" value={formData.month} onChange={handleChange}>
                      {[
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                      ].map((m) => (
                        <option key={m}>{m}</option>
                      ))}
                    </select>

                    <select name="year" value={formData.year} onChange={handleChange}>
                      {Array.from({ length: 110 }).map((_, i) => {
                        const y = 2025 - i;
                        return <option key={y}>{y}</option>;
                      })}
                    </select>
                  </div>
                  <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                  >
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>


                  <button type="submit" className="primary-btn" disabled={loading}>
                    {loading ? "Generating..." : "Show My Destiny Number"}
                  </button>

                </form>
              </div>
            </>
          )}

          {/* REPORT VIEW */}
          {showReport && (
            <div className="report-card">

              <h1>Your Birth / Root Number Report</h1>

              {resultData?.error ? (
                <p className="error-text">{resultData.error}</p>
              ) : (
                <>
                  <div className="hero-number-box">
                    <div className="number-circle">{destinyNum}</div>
                    <h2>{profile?.title}</h2>
                    <p className="keywords">{profile?.keywords}</p>
                  </div>

                  <div className="report-section">
                    <h3>Overview</h3>
                    <p>{profile?.overview}</p>
                  </div>

                  <div className="report-section">
                    <h3>Your Strengths</h3>
                    <ul>{profile?.strengths.map((s, i) => <li key={i}>{s}</li>)}</ul>
                  </div>

                  <div className="report-section">
                    <h3>Your Challenges</h3>
                    <ul>{profile?.challenges.map((c, i) => <li key={i}>{c}</li>)}</ul>
                  </div>

                  <div className="report-section">
                    <h3>Guidance</h3>
                    <p>{profile?.guidance}</p>
                  </div>
                </>
              )}

              <button className="try-again-btn" onClick={handleTryAgain}>
                Try Again
              </button>
            </div>
          )}
        </div>

        {/* RIGHT SIDEBAR */}
        <div className="right-numerology">
          <h4>Related Links</h4>
          <div className="right-links">
            <Link to="/numerology/luckynum"><p><img src={arrow} /> Lucky Number</p></Link>
            <Link to="/numerology/chinese-lucky"><p><img src={arrow} /> Chinese Lucky</p></Link>
            <Link to="/numerology/unlucky"><p><img src={arrow} /> Unlucky Number</p></Link>
            <Link to="/numerology/life-path"><p><img src={arrow} /> Life Path</p></Link>
            <Link to="/numerology/destiny"><p><img src={arrow} /> Destiny Number</p></Link>
            <Link to="/numerology/birth"><p><img src={arrow} /> Birth or Root Number</p></Link>
            <Link to="/numerology/soul"><p><img src={arrow} /> Soul Urge Number</p></Link>
            <Link to="/numerology/name"><p><img src={arrow} /> Name Number</p></Link>
            <Link to="/numerology/balance"><p><img src={arrow} /> Balance Number</p></Link>
            <Link to="/numerology/lo-shu-grid"><p><img src={arrow} /> Lo Shu Grid Analysis</p></Link>
            <Link to="/numerology/kua"><p><img src={arrow} /> Kua Number</p></Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Birth;